import { documentationActions } from '../../actions/constant';

const {
  RECHECK_DISCHARGE_OVERRIDE_STATUS_SUCCESS,
  RECHECK_DISCHARGE_OVERRIDE_STATUS_FAILURE,
  RECHECK_DISCHARGE_OVERRIDE_STATUS_LOADING,
  RECHECK_DISCHARGE_OVERRIDE_STATUS_RESET,
} = documentationActions;

const intitialstate: object = {
  response: null,
  isSuccess: false,
  loading: false,
};

export const recheckDischargeOverrideStatusReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case RECHECK_DISCHARGE_OVERRIDE_STATUS_SUCCESS: {
      return {
        ...state,
        isSuccess: true,
        // API body is `{ ...meta, data: <boolean> }`; expose the boolean directly
        // so consumers can read `response === true`.
        response: action.payload?.data,
        loading: false,
      };
    }

    case RECHECK_DISCHARGE_OVERRIDE_STATUS_FAILURE:
      return {
        ...state,
        isSuccess: false,
        response: action.payload,
        loading: false,
      };

    case RECHECK_DISCHARGE_OVERRIDE_STATUS_LOADING:
      return {
        ...state,
        loading: true,
      };

    case RECHECK_DISCHARGE_OVERRIDE_STATUS_RESET:
      return intitialstate;

    default:
      return state;
  }
};
